import { useContext } from 'react';

import { SearchContextProviderContext } from './SearchContextProvider.context.ts';

export const useSearchContext = () => {
  const context = useContext(SearchContextProviderContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};
